import React from 'react';
import logoImg from "../../assets/logo.png";
import { NavLink } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

export const Footer = () => {

    return (
        <>
            <div className='footer'>
                <div className='footer-wraper'>
                    <div className='footer-logo'>
                        <div className='logo'>
                            <img src={logoImg} alt="logo" loading="lazy" />
                        </div>
                    </div>
                    <div className='footer-social'>
                        <ul>
                            <li>
                                <NavLink to="mailto:support@houseofkurties.in" target='_blank'>
                                    <EmailIcon />
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="https://www.facebook.com/houseofkurtiesbdq" target='_blank'>
                                    <FacebookIcon />
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="https://www.instagram.com/houseofkurties/" target='_blank'>
                                    <InstagramIcon />
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="https://www.youtube.com/@houseofkurties" target='_blank'>
                                    <YouTubeIcon />
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='footer-links'>
                        <ul>
                            <li>
                                <NavLink to="/term-of-use">
                                    Terms of Use
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/terms-of-delivery">
                                    Terms of Delivery
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/privacy-policy">
                                    Privacy Policy
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/refund-returns">
                                    Refund & Returns Policy
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='footer-copyright'>
                        <p>
                            House of Kurties a venture of
                            {" "}
                            <NavLink to="https://www.gangaramenterprises.com/" target='_blank'>Gangaram Enterprises</NavLink>
                            {" "}
                            – Copyright 2024
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
